export default __webpack_public_path__ + "static/media/5.95a9b6ea.jpg";